module.exports = __webpack_public_path__ + "ca72c4581f7399f35916bf485abdd976.pdf";